@if (isLoading()) {
  <ngx-skeleton-loader
    class="custom-skeleton"
    [count]="1"
    animation="pulse"
    appearance="line"
    [theme]="{height: '40px', background: 'var(--skeleton-color)'}"
  />

  <div class="row mb-4">
    @for (_ of [].constructor(3); track $index) {
      <div class="col-md-4">
        <ngx-skeleton-loader
          class="custom-skeleton"
          [count]="1"
          animation="pulse"
          appearance="line"
          [theme]="{height: '222.56px', background: 'var(--skeleton-color)'}"
        />
      </div>
    }
  </div>


  <ul class="nav nav-tabs mb-1">
    <ngx-skeleton-loader
      class="custom-skeleton"
      [count]="1"
      animation="pulse"
      appearance="line"
      [theme]="{height: '40.51px', width:'290.64px', background: 'var(--skeleton-color)'}"
    />

  </ul>
  <div *ngIf="activeTab === 'services'">
    <div class="card">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="3"
        animation="pulse"
        appearance="line"
        [theme]="{height: '40.51px', width:'99.75px', background: 'var(--skeleton-color)'}"
      />
    </div>
  </div>
  <div class="d-flex flex-column gap-y-2">
    <ul class="nav nav-tabs m-1 p-0">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '40.51px', width:'1293.7px', background: 'var(--skeleton-color)'}"
      />
    </ul>
  </div>
  <div class="d-flex justify-content-between gap-2">
    <div class="card col-md-6">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '173.56px', width:'642.84px', background: 'var(--skeleton-color)'}"
      />
    </div>

    <div class="card col-md-3">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '173.56px', width:'321.42px', background: 'var(--skeleton-color)'}"
      />
    </div>
    <div class="card col-md-3">
        <ngx-skeleton-loader
          class="custom-skeleton"
          [count]="1"
          animation="pulse"
          appearance="line"
          [theme]="{height: '173.56px', width:'321.42px', background: 'var(--skeleton-color)'}"
        />
    </div>
  </div>


} @else {

  <div class="card mb-0">
    <div class="card-header bg-light p-0">
      <app-page-title [breadcrumbItems]="breadCrumbItems" [title]="data() | fullName">
        <div>
          <button class="btn btn-primary me-2" (click)="onEdit()">
            <i class="bi bi-pencil-square"></i> {{ 'RESIDENTS.EDIT_RESIDENT_INFO'| translate }}
          </button>
        </div>
      </app-page-title>
    </div>
  </div>
  <div class="py-4 resident-profile-wrapper">
    <!-- Contact & Bank Info -->
    <div class="row mb-4">
      <div class="col-md-4">
        <div class="card h-100 mb-0">
          <div class="card-header bg-light ">
            <h5 class="mb-0">{{ 'RESIDENTS.CONTACTINFO' | translate }}</h5>
          </div>
          <div class="card-body d-flex justify-content-start gap-5">
            <div>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.IDCARD' | translate }}</strong> {{ data().idCardNumber }}
              </p>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.B_DATE' | translate }}</strong> {{ data().birthDate | date:'longDate' }}
              </p>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.STATE' | translate }}: </strong> <span>Bayern (BY)</span>
              </p>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.ADDRESS' | translate }}: </strong> <span>Kirchplatz 5 </span>
              </p>
            </div>
            <div>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.PHONE' | translate }}</strong> {{ data().phoneNumber }}
              </p>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.EMAIL' | translate }}</strong> {{ data().email }}
              </p>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.TAXCODE'| translate }}</strong> {{ data().taxCode }}
              </p>
              <p class="m-0">
                <strong>{{ 'RESIDENTS.S_STATUS' | translate }}</strong> {{ data().socialStatus }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3 mt-md-0">
        <div class="card h-100 mb-0">
          <div class="card-header bg-light ">
            <h5 class="mb-0">{{ 'RESIDENTS.APARTMENT_INFO' | translate }}</h5>
          </div>
          <div class="card-body">
            <p class="m-0">
              <strong>{{ 'RESIDENTS.APARTMENT' | translate }}: </strong> Bocholt, Weberstr 6. Floor 1, Number 101
            </p>
            <p class="m-0">
              <strong>{{ 'RESIDENTS.LIVING_AREA' | translate }}: </strong> 53 m<sup>2</sup>
            </p>
            <p class="m-0">
              <strong>{{ 'RESIDENTS.INHABITANTS_COUNT' | translate }}: </strong> 3
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3 mt-md-0">
        <div class="card h-100 mb-0">
          <div class="card-header bg-light ">
            <h5 class="mb-0">{{ 'RESIDENTS.BANK_ACCOUNT' | translate }}</h5>
          </div>
          <div class="card-body">
            <p class="m-0">
              <strong>{{ 'RESIDENTS.ACCOUNT' | translate }}</strong> {{ data().bankAccount }}
              <span *ngIf="data().bankAccountConfirmation"
                    class="ms-2 badge bg-success">{{ 'RESIDENTS.CONFIRMED' | translate }}</span>
              <span *ngIf="!data().bankAccountConfirmation"
                    class="ms-2 badge bg-warning">{{ 'RESIDENTS.UNCONFIRMED' | translate }}</span>
            </p>
            <p class="m-0">
              <strong>{{ 'RESIDENTS.RENT_TYPE' | translate }}</strong> {{ data().rentType || 'N/A' }}
            </p>
            <p class="m-0">
              <strong>{{ 'RESIDENTS.ADDRESS_ID' | translate }}</strong> {{ 'RESIDENTS.STATE' | translate }}
              {{ data().stateId }}, {{ 'RESIDENTS.APT' | translate }} {{ data().apartmentId }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs for different sections -->
    <ul class="nav nav-tabs mb-1">
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{'active': activeTab === 'services'}"
          (click)="setActiveTab('services')"
        >{{ 'RESIDENTS.SERVICES' | translate }}</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{'active': activeTab === 'payments'}"
          (click)="setActiveTab('payments')"
        >{{ 'MENU.PAYMENTS' | translate }}</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{'active': activeTab === 'invoices'}"
          (click)="setActiveTab('invoices')"
        >{{ 'MENU.INVOICES' | translate }}</a
        >
      </li>
    </ul>

    <!-- Services Section -->
    <div *ngIf="activeTab === 'services'">
      <div class="card">
        <div class="card-header bg-light">
          <h5 class="mb-0">{{ 'RESIDENTS.C_SERVICES' | translate }}</h5>
        </div>
        <div class="d-flex flex-column gap-y-2">
          <ul class="nav nav-tabs m-1 p-0">
            <li class="nav-item" [ngClass]="{'bg-light' : activeServiceTab === 'cold-water'}">
              <a
                class="nav-link text-info"
                [ngClass]="{'active': activeTab === 'cold-water'}"
                (click)="setActiveServiceTab('cold-water')">
                {{ 'UNITTYPES.COLD_WATER' | translate }}
              </a>
            </li>
            <li class="nav-item" [ngClass]="{'bg-light' : activeServiceTab === 'warm-water'}">
              <a
                class="nav-link text-danger"
                [ngClass]="{'active': activeTab === 'warm-water'}"
                (click)="setActiveServiceTab('warm-water')">
                {{ 'UNITTYPES.WARM_WATER' | translate }}
              </a>
            </li>
            <li class="nav-item" [ngClass]="{'bg-light' : activeServiceTab === 'heating'}">
              <a
                class="nav-link text-warning"
                [ngClass]="{'active': activeTab === 'heating'}"
                (click)="setActiveServiceTab('heating')">
                {{ 'UNITTYPES.HEATING' | translate }}
              </a>
            </li>
          </ul>

          <div *ngIf="activeServiceTab === 'cold-water'" class="px-2">
            <div class="d-flex justify-content-between gap-2">
              <div class="card col-md-6">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'UNITTYPES.COLD_WATER' | translate }} {{ 'RESIDENTS.METER_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <div class="d-flex justify-content-between gap-2">
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.METER_TYPE' | translate }}: </strong> <span>EX-18</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SERIAL_NUMBER' | translate }}: </strong>
                        <span>AX899855</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SEAL_NUMBER' | translate }}: </strong> <span>SS8875556</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SEAL_DATE' | translate }}: </strong> <span>22.01.2025</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.INSTALLATION_LOCATION' | translate }}: </strong> <span>In the apartment</span>
                      </p>
                    </div>
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.STATUS' | translate }}: </strong> <span
                        class="ms-2 badge bg-primary">Working</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.INSTALLATION_DATE' | translate }}: </strong>
                        <span>24.05.2023</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.LAST_READING' | translate }}: </strong> <span>253.000</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.BALANCE' | translate }}: </strong> <span>€565.00</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.PAYMENT_DATE' | translate }}: </strong>
                        <span>20.01.2025</span></p>
                    </div>
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.CERTIFICATE_NUMBER' | translate }}: </strong>
                        <span>BB-180055</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.CERTIFICATE_TYPE' | translate }}: </strong> <span>MID</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.DATE' | translate }}: </strong> <span>24.05.2023</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.END_DATE' | translate }}: </strong> <span>25.05.2033</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-3">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'RESIDENTS.CONTRACT_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <p class="m-0"><strong>{{ 'RESIDENTS.NUMBER' | translate }}: </strong> <span>33401562389</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.CONTRACT_DATE' | translate }}: </strong> <span>23.05.2023</span>
                  </p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.UPDATE_DATE' | translate }}: </strong> <span>22.05.2024</span>
                  </p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.END_DATE' | translate }}: </strong> <span>22.05.2025</span></p>
                </div>
              </div>
              <div class="card col-md-3">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'RESIDENTS.TARIFF_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <p class="m-0"><strong>{{ 'RESIDENTS.CODE' | translate }}: </strong> <span>055</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.NAME' | translate }}: </strong> <span>Middle</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.PRICE' | translate }}: </strong> <span>€2.00</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.UPDATE_DATE' | translate }}: </strong> <span>22.04.2024</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="activeServiceTab === 'warm-water'" class="px-2">
            <div class="d-flex justify-content-between gap-2">
              <div class="card col-md-6">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'UNITTYPES.WARM_WATER' | translate }} {{ 'RESIDENTS.METER_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <div class="d-flex justify-content-between gap-2">
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.METER_TYPE' | translate }}: </strong> <span>EX-18</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SERIAL_NUMBER' | translate }}: </strong>
                        <span>AX899855</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SEAL_NUMBER' | translate }}: </strong> <span>SS8875556</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SEAL_DATE' | translate }}: </strong> <span>22.01.2025</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.INSTALLATION_LOCATION' | translate }}: </strong> <span>In the apartment</span>
                      </p>
                    </div>
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.STATUS' | translate }}: </strong> <span
                        class="ms-2 badge bg-primary">Working</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.INSTALLATION_DATE' | translate }}: </strong>
                        <span>24.05.2023</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.LAST_READING' | translate }}: </strong> <span>253.000</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.BALANCE' | translate }}: </strong> <span>€565.00</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.PAYMENT_DATE' | translate }}: </strong>
                        <span>20.01.2025</span></p>
                    </div>
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.CERTIFICATE_NUMBER' | translate }}: </strong>
                        <span>BB-180055</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.CERTIFICATE_TYPE' | translate }}: </strong> <span>MID</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.DATE' | translate }}: </strong> <span>24.05.2023</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.END_DATE' | translate }}: </strong> <span>25.05.2033</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-3">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'RESIDENTS.CONTRACT_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <p class="m-0"><strong>{{ 'RESIDENTS.NUMBER' | translate }}: </strong> <span>33401562389</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.CONTRACT_DATE' | translate }}: </strong> <span>23.05.2023</span>
                  </p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.UPDATE_DATE' | translate }}: </strong> <span>22.05.2024</span>
                  </p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.END_DATE' | translate }}: </strong> <span>22.05.2025</span></p>
                </div>
              </div>
              <div class="card col-md-3">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'RESIDENTS.TARIFF_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <p class="m-0"><strong>{{ 'RESIDENTS.CODE' | translate }}: </strong> <span>055</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.NAME' | translate }}: </strong> <span>Middle</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.PRICE' | translate }}: </strong> <span>€2.00</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.UPDATE_DATE' | translate }}: </strong> <span>22.04.2024</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="activeServiceTab === 'heating'" class="px-2">
            <div class="d-flex justify-content-between gap-2">
              <div class="card col-md-6">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'UNITTYPES.HEATING' | translate }} {{ 'RESIDENTS.METER_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <div class="d-flex justify-content-between gap-2">
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.METER_TYPE' | translate }}: </strong> <span>EX-18</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SERIAL_NUMBER' | translate }}: </strong>
                        <span>AX899855</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SEAL_NUMBER' | translate }}: </strong> <span>SS8875556</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.SEAL_DATE' | translate }}: </strong> <span>22.01.2025</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.INSTALLATION_LOCATION' | translate }}: </strong> <span>In the apartment</span>
                      </p>
                    </div>
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.STATUS' | translate }}: </strong> <span
                        class="ms-2 badge bg-primary">Working</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.INSTALLATION_DATE' | translate }}: </strong>
                        <span>24.05.2023</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.LAST_READING' | translate }}: </strong> <span>253.000</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.BALANCE' | translate }}: </strong> <span>€565.00</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.PAYMENT_DATE' | translate }}: </strong>
                        <span>20.01.2025</span></p>
                    </div>
                    <div class="col-md-4 px-2">
                      <p class="m-0"><strong>{{ 'RESIDENTS.CERTIFICATE_NUMBER' | translate }}: </strong>
                        <span>BB-180055</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.CERTIFICATE_TYPE' | translate }}: </strong> <span>MID</span>
                      </p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.DATE' | translate }}: </strong> <span>24.05.2023</span></p>
                      <p class="m-0"><strong>{{ 'RESIDENTS.END_DATE' | translate }}: </strong> <span>25.05.2033</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-3">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'RESIDENTS.CONTRACT_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <p class="m-0"><strong>{{ 'RESIDENTS.NUMBER' | translate }}: </strong> <span>33401562389</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.CONTRACT_DATE' | translate }}: </strong> <span>23.05.2023</span>
                  </p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.UPDATE_DATE' | translate }}: </strong> <span>22.05.2024</span>
                  </p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.END_DATE' | translate }}: </strong> <span>22.05.2025</span></p>
                </div>
              </div>
              <div class="card col-md-3">
                <div class="card-header px-2 pt-2 pb-0 bg-light">
                  <h5 class="">{{ 'RESIDENTS.TARIFF_INFO' | translate }}</h5>
                </div>
                <div class="card-body p-2">
                  <p class="m-0"><strong>{{ 'RESIDENTS.CODE' | translate }}: </strong> <span>055</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.NAME' | translate }}: </strong> <span>Middle</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.PRICE' | translate }}: </strong> <span>€2.00</span></p>
                  <p class="m-0"><strong>{{ 'RESIDENTS.UPDATE_DATE' | translate }}: </strong> <span>22.04.2024</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payments Section -->
    <div *ngIf="activeTab === 'payments'">
      <app-resident-payments [residentId]="id"></app-resident-payments>
    </div>

    <!-- Invoices Section -->
    <div *ngIf="activeTab === 'invoices'">
      <app-resident-invoices [residentId]="id"></app-resident-invoices>
    </div>
  </div>
}

